<template>
  <table class="table table-striped table-condensed">
    <thead>
    <tr>
      <th class="col-xs-2">
      </th>

      <th class="col-xs-5">
        <a href="#" @click.prevent="sort('period')">
          Period <i class="fa fa-sort"></i>
        </a>
      </th>

      <th class="col-xs-3">
        <a href="#" @click.prevent="sort('index')">
          Index <i class="fa fa-sort"></i>
        </a>
      </th>

      <th class="col-xs-4">
        <a href="#" @click.prevent="sort('value')">
          Revenue <i class="fa fa-sort"></i>
        </a>
      </th>

      <th class="col-xs-4">
        <a href="#" @click.prevent="sort('target')">
          Target <i class="fa fa-sort"></i>
        </a>
      </th>

      <th class="col-xs-6">
        <a href="#" @click.prevent="sort('difference')">
          Difference <i class="fa fa-sort"></i>
        </a>
      </th>
    </tr>
    </thead>

    <tbody>
    <tr v-for="row in rows">
      <td class="text-center">
        <input type="checkbox" v-model="selected" :value="row">
      </td>

      <td>
        {{ row.period }}
      </td>

      <td>
        <IndexNumber :value="row.index"/>
      </td>

      <td>
        {{ row.value | price }}
      </td>

      <td>
        {{ row.target | price }}
      </td>

      <td>
        <DifferenceNumber :value="row.difference"/>
      </td>
    </tr>
    </tbody>

    <tfoot>
    <tr>
      <td></td>

      <td>
        Total
      </td>

      <td>
        <IndexNumber :value="totalIndex"/>
      </td>

      <td>
        {{ totalValue | price }}
      </td>

      <td>
        {{ totalTarget | price }}
      </td>

      <td>
        <DifferenceNumber :value="totalDifference"/>
      </td>
    </tr>

    <tr>
      <td></td>

      <td>
        Selected Total
      </td>

      <td>
        <index-number :value="selectedIndex"></index-number>
      </td>

      <td>
        {{ selectedValue | price }}
      </td>

      <td>
        {{ selectedTarget | price }}
      </td>

      <td>
        <difference-number :value="selectedDifference"></difference-number>
      </td>
    </tr>
    </tfoot>
  </table>
</template>

<script>
import DifferenceNumber from '@/components/Numbers/DifferenceNumber'
import IndexNumber from '@/components/Numbers/IndexNumber'

export default {
  components: {IndexNumber, DifferenceNumber},

  props: {
    targetMetric: {},
    selectedPortal: {},
    granularity: {},
    data: {},
    dataset: {}
  },

  data() {
    return {
      sortBy: 'period',
      sortDirection: -1,

      selected: []
    }
  },

  watch: {
    data() {
      this.selected = []
    }
  },

  computed: {
    internalTargetMetric() {
      return this.targetMetric === 'ad_target' ? 'target' : 'management_target'
    },

    rows() {
      return this.data.periods
          .map((period, index) => ({
            period,
            value: this.data.datasets.filter(dataset => this.dataset ? dataset.id === this.dataset : true).map(dataset => dataset.values).reduce((result, row) => result + row[index], 0),
            target: this.data.datasets.filter(dataset => this.dataset ? dataset.id === this.dataset : true).map(dataset => dataset[this.internalTargetMetric]).reduce((result, row) => result + row[index], 0),
          }))
          .map(row => ({
            period: row.period,
            value: row.value,
            target: row.target,
            difference: row.value - row.target,
            index: row.target ? row.value / row.target * 100 : 0,
          }))
          .sort((a, b) => {
            return a[this.sortBy] > b[this.sortBy] ? -this.sortDirection : this.sortDirection
          })
    },

    totalValue() {
      return this.rows.reduce((total, row) => total + row.value, 0)
    },

    totalTarget() {
      return this.rows.reduce((total, row) => total + row.target, 0)
    },

    totalIndex() {
      if (!this.totalTarget) {
        return null
      }

      return this.totalValue / this.totalTarget * 100
    },

    totalDifference() {
      return this.totalValue - this.totalTarget
    },

    selectedValue() {
      return this.selected.reduce((total, row) => total + row.value, 0)
    },

    selectedTarget() {
      return this.selected.reduce((total, row) => total + row.target, 0)
    },

    selectedIndex() {
      if (!this.selectedTarget) {
        return null
      }

      return this.selectedValue / this.selectedTarget * 100
    },

    selectedDifference() {
      return this.selectedValue - this.selectedTarget
    }
  },

  methods: {
    sort(key) {
      if (this.sortBy === key) {
        return this.sortDirection = -this.sortDirection
      }

      this.sortDirection = key === 'period' ? -1 : 1

      this.sortBy = key
    }
  }
}
</script>